import React, { useEffect } from 'react';
import FilterSection from './components/FilterSection';
import ProductGrid from './components/ProductGrid';
import './EbooksApp.css';
import productsData from '../ebooks/components/data/ProductsData';
import EbookHero from './components/EbookHero';
import SEO from '../SEO/SEO';

function EbooksApp() {

  return (
    <div className="ebooks-app-container" id='id-ebook'>
      {/*<FilterSection />*/}
      <EbookHero />
      <div className='ebooks-product-grid-container'>
        <ProductGrid products={productsData} />
      </div>
    </div>
  );
}

export default EbooksApp;